module.exports = __webpack_public_path__ + "img/gongye_bg.b0ebb02a.png";